<div class="pagination-container flex items-center space-x-3.5">
  <!-- First Page Button -->
  <button
    (click)="goToPage(1)"
    [disabled]="currentPage === 1"
    [style.opacity]="currentPage === 1 ? 0 : 1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m12 6l-6 6l6 6m6-12l-6 6l6 6"
      />
    </svg>
  </button>

  <!-- Previous Page Button -->
  <button
    (click)="navigatePage('prev')"
    [style.opacity]="currentPage === 1 ? 0 : 1"
    [disabled]="currentPage === 1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.53 2.97a.75.75 0 0 1 0 1.06L6.56 8l3.97 3.97a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0"
        clip-rule="evenodd"
      />
    </svg>
  </button>

  <span>Page {{ currentPage }} of {{ totalPages }}</span>

  <!-- Next Page Button -->
  <button
    (click)="navigatePage('next')"
    [disabled]="currentPage === totalPages"
    [style.opacity]="currentPage === totalPages ? 0 : 1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.47 13.03a.75.75 0 0 1 0-1.06L9.44 8L5.47 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0"
        clip-rule="evenodd"
      />
    </svg>
  </button>

  <!-- Last Page Button -->
  <button
    (click)="goToPage(totalPages)"
    [disabled]="currentPage === totalPages"
    [style.opacity]="currentPage === totalPages ? 0 : 1"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m12 18l6-6l-6-6M6 18l6-6l-6-6"
      />
    </svg>
  </button>
</div>
